import { render, staticRenderFns } from "./simple_rubric_preview_table.vue?vue&type=template&id=2c1dd39e&scoped=true&"
import script from "./simple_rubric_preview_table.vue?vue&type=script&lang=js&"
export * from "./simple_rubric_preview_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1dd39e",
  null
  
)

export default component.exports